import { BusinessRegion } from '../models/business-region.model';

export const PrivacyNoticeContent = {
  [BusinessRegion.ChineseMainland]: {
    title: '“DES-数字化EHS系统”隐私政策',
    localContent: `
      <div>
        太古可口可乐（中国）有限公司及其关联公司（下文简称“太古可口可乐”或“我们”）的 “DES-数字化EHS系统”隐私政策适用于，登录太古可口可乐“DES-数字化EHS系统”的所有人。我们希望通过本政策向您说明您在使用“DES-数字化EHS系统”时，我们如何通过收集、使用、存储、加工、传输、提供、公开、删除等方式处理（统称“处理”）个人信息，以及我们为您提供的访问、更新和保护这些信息的方式。请用“DES-数字化EHS系统”之前，仔细阅读并理解本政策，并经常访问以了解本政策的更新。
      </div>
      
      <div>
        您在点击“同意”时，我们将会视为：
      </div>
      
      <ul>
        <li>您已经了解并同意本政策的内容，并且同意太古可口可乐可以按照本政策所述的方式：
          <ol>
            <li>收集、使用、处理和共享您的个人信息；</li>
          </ol>
        </li>
        <li>就您所知，您向我们提供的所有信息是真实和准确的，未故意隐瞒及遗漏任何相关的全部或部分信息。</li>
      </ul>
      
      <div><b>1. 概述</b></div>
      
      <div>
        本政策将帮助您了解以下内容：
      </div>
      
      <ul>
        <li>我们如何收集、处理您的个人信息</li>
        <li>在法律规定或特定情况下，我们免除征得您的授权同意处理个人信息的情况</li>
        <li>我们如何委托处理、共享、转让、公开披露您的个人信息</li>
        <li>我们如何保护您的个人信息</li>
        <li>您作为个人信息主体的权利</li>
        <li>您的个人信息的保留期限</li>
        <li>您的个人信息如何存储和转移</li>
        <li>本政策如何更新</li>
        <li>如何联系我们</li>
      </ul>
      
      <div><b>2. 定义</b></div>
      
      <ul>
        <li><b>个人信息：</b>是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</li>
        <li><b>敏感个人信息：</b>是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。</li>
        <li><b>太古可口可乐的关联公司：</b>指我们位于中国大陆地区的，广东太古可口可乐有限公司，浙江太古可口可乐饮料有限公司，合肥太古可口可乐饮料有限公司，江苏太古可口可乐饮料有限公司，厦门太古可口可乐饮料有限公司，厦门绿泉实业有限公司，郑州太古可口可乐饮料有限公司，广西太古可口可乐饮料有限公司，海南太古可口可乐饮料有限公司，湖北太古可口可乐饮料有限公司，江西太古可口可乐饮料有限公司，上海申美饮料食品有限公司，广东太古可口可乐湛江有限公司，云南太古可口可乐饮料有限公司，广东太古可口可乐惠州有限公司，温州太古可口可乐饮料有限公司，漯河太古可口可乐饮料有限公司，太古可口可乐(苏州)饮料有限公司，可口可乐装瓶商生产(东莞)有限公司，可口可乐装瓶商生产(武汉)有限公司，可口可乐装瓶商生产(佛山)有限公司，可口可乐装瓶商生产(杭州)有限公司，可口可乐装瓶商生产(苏州)有限公司，可口可乐装瓶商生产(南宁)有限公司。</li>
        <li><b>根据《中华人民共和国个人信息保护法》</b>，个人信息的<b>处理</b>方式包括收集、储存、使用、加工、传输、提供、公开、删除等。</li>
      </ul>
      
      <div>
        除非另有说明，否则本政策中“包括”一词指“包括但不限于”。
      </div>
      
      <div><b>3. 我们如何收集、处理您的个人信息</b></div>
      
      <div>
        为实现管理厂房承包商、保障厂区安全、访问管理与合规目的，DES系统将依据最小必要原则收集下列与承包商相关的个人信息。
      </div>
      
      <ol>
        <li>
          身份与登记信息（用于身份核验、入厂管理与安全合规）
          <ul>
            <li>法人姓名</li>
            <li>法人身份证号码（敏感个人信息）</li>
            <li>承包商公司名称</li>
            <li>承包商编号</li>
          </ul>
        </li>
        <li>
          联系方式（用于联系、紧急通知）
          <ul>
            <li>移动电话号码</li>
            <li>电子邮箱</li>
          </ul>
        </li>
        <li>
          支付信息（用于联系、紧急通知）
          <ul>
            <li>开户行/账户名称</li>
            <li>银行账号</li>
          </ul>
        </li>
      </ol>
      
      <div><b>4. 在法律规定或特定情况下，我们免除征得您的授权同意处理个人信息的情况</b></div>
      
      <div>
        4.1. 您充分知晓并同意在以下情形中，我们处理您的个人信息时不必征得您的授权同意：
      </div>
      
      <ol>
        <li>
          我们履行法律法规规定的职责或义务所必需的，包括：
          <ol>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与犯罪侦查、起诉、审判和判决执行等直接相关的或根据中国大陆行政机关或执法机关的要求的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
          </ol>
        </li>
        <li>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</li>
        <li>为应对突发公共卫生事件，或在紧急情况下为保护您或其他自然人的生命健康和财产安全所必需的；</li>
        <li>在合理的范围内处理您自行公开或者其他已经合法公开（包括从合法的新闻报道、政府信息公开等渠道）的个人信息；</li>
        <li>用于维护网站的安全稳定运行所必须的，例如发现、处置网站运行的故障；</li>
        <li>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</li>
        <li>法律法规规定的其他情形及更新后的法律法规规定的其他情形。</li>
      </ol>
      
      <div>
        4.2. 您理解如果我们对收集的您的个人信息进行技术处理匿名化或去标识化，使得您的身份无法被识别，或使得您的身份在无法在不借助额外信息的情况下被识别，则我们之后使用此类信息时无需另行向您通知并征得您的同意。
      </div>
      
      <div><b>5. 在法律规定或特定情况下，我们如何委托处理、共享、转让、公开披露您的个人信息</b></div>
      
      <div>
        5.1. 委托处理及共享
      </div>
      
      <ol>
        <li>原则上，在未经您事先同意的情况下，我们不会将您的个人信息提供给除太古可口可乐以外的任何第三方公司、组织或个人。</li>
        <li>与我们委托处理个人信息的公司、组织和个人共享您的个人信息前 （包括您的<b>敏感个人信息</b>），我们会与其签订委托合同确认委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务并对受委托方的个人信息处理活动进行监督，要求他们按照我们的要求、本政策以及其他相关的保密和安全措施来处理您的个人信息，并要求其在处理目的达成后对个人信息予以删除或返还。我们将严格管控第三方按照中华人民共和国的法律法规要求履行其对个人信息保护的义务。</li>
      </ol>
      
      <div>
        5.2. 转让
      </div>
      
      <div>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </div>
      
      <ol>
        <li>在获取明确同意的情况下转让。获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
        <li>在我们涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意；或</li>
        <li>根据适用的法律法规、法律程序的要求、强制性的行政或司法要求。</li>
      </ol>
      
      <div>
        5.3. 公开披露
      </div>
      
      <div>
        我们仅会在以下情况下，公开披露您的个人信息：
      </div>
      
      <ol>
        <li>获得您明确同意或主动选择情况下；或</li>
        <li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
      </ol>
      
      <div><b>6. 我们如何保护您的个人信息</b></div>
      
      <div>
        6.1. 我们确保采取适当措施维护个人信息的安全性，保护个人信息免遭未经授权的访问、非法处理、丢失或使用。应保护个人信息免遭未经授权的访问或非法处理、使用、修改或披露、被未经授权的第三方拦截、擦除、意外丢失或破坏或损坏。我们会执行充足的安全控制，以保护个人信息。
      </div>
      
      <div>
        6.2. 有关个人敏感信息的传输和存储安全措施，会采用更高规格的措施，依据相关法律法规执行适当的行政管理及安全防护措施与程序以保障个人信息安全，以防止个人信息被未经授权或不法处理，以及避免个人信息遭受意外损失、毁坏或损害。
      </div>
      
      <div>
        6.3. 除非法律法规另有规定或您另行授权同意，我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息。
      </div>
      
      <div>
        6.4. 我们将尽力确保或担保您发送给我们的任何信息的安全性并会采取适当的措施。如果您对我们实施的安全措施有任何疑问，请通过第11条所列方式联系我们。
      </div>
      
      <div>
        6.5. 如发生个人信息安全状况，我们将按照法律法规的要求，及时向您告知安全事件的基本情况、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以您提供给我们的联系信息等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </div>
      
      <div><b>7. 您作为个人信息主体的权利</b></div>
      
      <div>
        7.1. 按照中华人民共和国法律法规要求，针对我们持有的您的个人信息，您享有如下相关权利，并可通过第11条所列方式提出权利请求：
      </div>
      
      <ol>
        <li>查阅、复制个人信息；</li>
        <li>转移个人信息；</li>
        <li>更正、补充任何您的不准确的个人信息；</li>
        <li>要求我们删除您的个人信息；</li>
        <li>对个人信息处理规则进行解释说明。</li>
      </ol>
      
      <div>
        原则上，我们核实您的身份后，视乎权利请求的性质，我们将在15个工作日内回复您的权利请求。
      </div>
      
      <div>
        7.2. 在以下情形中，我们将拒绝您的请求：
      </div>
      
      <ol>
        <li>与我们履行法律法规规定的义务相关，比如我们根据中华人民共和国法律法规要求向政府部门提供您的个人信息的（可能包括您的<b>敏感个人信息</b>）；</li>
        <li>法律法规规定的数据保存期限未届满、或者删除个人信息从技术上难以实现的（在此种情形下我们会采取必要的安全保护措施保障您的个人信息安全）；</li>
        <li>与国家安全、国防安全直接相关的；</li>
        <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>与犯罪侦查、起诉、审判和执行判决等直接相关的；</li>
        <li>我们有充分证据表明您存在主观恶意或滥用权利的；</li>
        <li>出于维护您或其他个人的生命、财产等重大合法权益；</li>
        <li>响应您的请求将导致您或其他个人、组织（包括我们）的合法权益受到严重损害的；</li>
        <li>涉及商业秘密的。</li>
      </ol>
      
      <div><b>8. 个人信息的保留期限</b></div>
      
      <div>
        一般而言，我们坚持数据存储“最小化”原则，仅为实现厂房安全的目的所必需的最短时间保留您的个人信息；在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。保留期限届满后您的个人信息将会被安全有效地销毁或永久从IT系统内删除或匿名化处理。
      </div>
      
      <div>
        但如果您不希望我们保留您的个人信息，您也可以通过第11条所列方式告知我们删除您的个人信息。我们将在15个工作日内回复您的权利请求。
      </div>
      
      <div><b>9. 您的个人信息如何存储和转移</b></div>
      
      <div>
        原则上，我们在中华人民共和国境内根据本政策第3条的业务目的收集和产生的个人信息，将存储在中华人民共和国境内。
      </div>
      
      <div><b>10. 本政策如何更新</b></div>
      
      <div>
        10.1. 本政策可能变更。未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会以系统公告方式发布对本政策所做的任何变更。
      </div>
      
      <div>
        10.2. 对于重大变更，我们还会不时向您提供合适通知。
      </div>
      
      <div>
        10.3. 本政策所指的重大变更包括但不限于：
      </div>
      
      <ol>
        <li>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
        <li>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</li>
        <li>您参与个人信息处理方面的权利及其行使方式发生重大变化时；</li>
        <li>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</li>
        <li>个人信息安全影响评估报告表明存在高风险时。</li>
      </ol>
      
      <div>
        我们还会将本政策的旧版本存档，供您查阅。
      </div>
      
      <div><b>11. 如何联系我们</b></div>
      
      <div>
        11.1. 如您对本政策的内容有任何疑问、意见或建议，您可通过您所在的太古可口可乐的关联公司、关联公司的行政部门等与我们联系；
      </div>
      
      <div>
        11.2. 此外，我们还设立了个人信息保护专职部门，如果您对本政策有任何疑问、意见或建议，或欲根据本政策行使您对自己的个人信息的权利，欢迎与我们联络，联络方式为：
      </div>
      
      <ul>
        <li>部门名称：个人信息保护办公室（中国）</li>
        <li>电子邮件：dppoc@swirecocacola.com</li>
        <li>地址： 浙江省杭州市上城区采荷路41号8楼</li>
      </ul>
      
      <div>
        一般情况下，我们将在收到您的请求15个工作日内回复。如果您对我们的回复不满意，或认为我们的个人信息处理行为损害了您的合法权益，您还可以通过其它途径如法院诉讼或向其他行政监管部门寻求解决方案。
      </div>
    `,
    localLanguageName: '简体中文'
  },
  [BusinessRegion.HongKong]: {
    title: '收集個人資料聲明 / Personal Information Collection Statement',
    enContent: `
      <div>
        This Personal Information Collection Statement (the “Statement”) is made in accordance with the requirements of the Personal Data (Privacy) Ordinance (PD(P)O) of Hong Kong and the Privacy Policy of Swire Coca-Cola Limited T/A Swire Coca-Cola HK (“SCCHK”, “we”, “us” and “our”). The most current version will be available on <a href="https://www.swirecocacola.com/en/Others/Privacy-Policies.html" target="_blank">our website</a>.
      </div>

      <div><b>1. Purpose and Scope of Collection of Personal Data</b></div>

      <div>
        For the purposes of contractor management, plant safety and security, access management, and regulatory compliance, the DES system will collect the following contractor-related personal data in accordance with the principle of data minimization.
      </div>
      
      <div>
        We may collect, verify and process certain personal data for contractor management, plant safety and security, access management, audit, investigation and regulatory compliance purposes. Such personal data may include, but is not limited to:
      </div>
      
      <ul>
        <li>Identification Information:
          <ul>
            <li>Full name</li>
            <li>Contractor Company</li>
            <li>Gender</li>
          </ul>
        </li>
        <li>Contact Information:
          <ul>
            <li>Email address</li>
            <li>Phone number</li>
          </ul>
        </li>
        <li>Verification Information:
          <ul>
            <li>Information required to verify your identity (if necessary)</li>
          </ul>
        </li>
      </ul>
      
      <div>
        The Personal Data you provide may be used for the following purposes:
      </div>
      
      <ul>
        <li>Managing plant contractors, ensuring plant safety and security, administering access control, and fulfilling regulatory compliance;</li>
        <li>Verifying your identity for contractor administration, site access and security purposes;</li>
        <li>Maintaining records for audit, security, legal and regulatory compliance purposes.</li>
      </ul>
      
      <div>
        We will only process your Personal Data for the purposes outlined above and will not use it for any other purpose without your consent unless required by law.
      </div>
      
      <div>
        Failure to provide the requested Personal Data may affect SCCHK's ability to manage contractor administration, site access, security requirements or compliance obligations. This will not, however, have an impact on any other existing products or services offered by the SCCHK.
      </div>

      <div><b>2. Disclosure of Personal Data</b></div>

      <div>
        SCCHK may disclose Personal Data to its group companies, service providers, professional advisers, regulators or governmental authorities where necessary for the purposes described in this Notice.
      </div>
      
      <div>
        Where Personal Data is transferred outside Hong Kong, appropriate safeguards will be implemented in accordance with applicable requirements.
      </div>

      <div><b>3. Retention of Personal Data</b></div>

      <div>
        Your Personal Data will be retained as long as necessary to fulfil the purpose for which it was collected. Personal Data may be retained for record-keeping, audit, legal and regulatory compliance purposes. Once the applicable purpose has been fulfilled and no further retention is required, Personal Data will be securely deleted or anonymised in accordance with our retention policies.
      </div>

      <div><b>4. Security Measures of Personal Data</b></div>
      
      <div>
        SCCHK will take all reasonable and practicable steps to protect Personal Data and maintain its security and accuracy in accordance with applicable data protection requirements. To protect your personal data, SCCHK has implemented a wide range of security measures and capabilities, including but not limited to:
      </div>

      <ul>
        <li>We use encryption to secure personal data, ensuring that it is protected during both transmission and storage to prevent unauthorized access or interception.</li>
        <li>We enforce strict access controls to ensure that only authorized personnel can access personal data, and we grant access solely on a need-to-know basis.</li>
        <li>We regularly monitor and audit our systems to swiftly detect and respond to any suspicious activity or potential security breaches.</li>
      </ul>
      
      <div>
        SCCHK implements reasonable technical and organisational measures to protect Personal Data against unauthorised access, use, disclosure, alteration or loss.
      </div>

      <div><b>5. Data Subject Rights</b></div>

      <div>
        In accordance with applicable laws in Hong Kong, you are entitled to exercise the following rights:
      </div>
      
      <ul>
        <li>Access your Personal Data held by us;</li>
        <li>Correct your Personal Data held by us.</li>
      </ul>

      <div>
        To exercise your rights under the PD(P)O, please contact us using the details in Section 8. SCCHK may take reasonable steps to verify the identity of the requester before processing a request.
      </div>

      <div><b>6. Public Disclosure</b></div>

      <div>
        SCCHK will not disclose Personal Data except as permitted or required by law.
      </div>

      <div><b>7. Privacy Policy</b></div>
      
      <div>
        If you would like to learn more about SCCHK's privacy policy, please visit <a href="https://www.swirecocacola.com/en/Others/Privacy-Policies.html" target="_blank">the following website</a>.
      </div>

      <div><b>8. Contact Us</b></div>
      
      <div>
        If you have any questions about how the SCCHK collects, processes or retains the Personal Data collected, or if you wish to exercise your rights as a data subject, please contact us as specified below:
      </div>
      
      <ul>
        <li><b>Data Privacy Protection Office</b></li>
        <li><b>E-mail:</b> dpo@hk.swirecocacola.com</li>
        <li><b>Address:</b> Swire Coca-Cola HK, 17-19 Yuen Shun Circuit, Siu Lek Yuen, Shatin, New Territories, Hong Kong. QSE Department</li>
      </ul>
    `,
    localContent: `
      <div>
        本收集個人資料聲明（下稱「本聲明」）乃根據香港《個人資料（私隱）條例》（PD(P)O）之規定，以及太古可口可樂有限公司 營業名稱為香港太古可口可樂（下稱「SCCHK」或「我們」）之《私隱政策》制定。最新版本可於<a href="https://www.swirecocacola.com/en/Others/Privacy-Policies.html" target="_blank">本公司網站</a>查閱。
      </div>

      <div><b>1. 收集個人資料的目的及範圍</b></div>

      <div>
        基於承辦商管理、廠房安全與保安、出入權限管理及法規遵從之目的，Digital EHS (DES) 系統將依據「資料最小化」原則收集以下與承辦商相關之個人資料。
      </div>
      
      <div>
        我們可能出於承辦商管理、廠房安全與保安、出入權限管理、審計、調查及法規遵從等目的，收集、核實及處理特定個人資料。該等個人資料可能包括但不限於：
      </div>
      
      <ul>
        <li>身份識別資料：
          <ul>
            <li>全名</li>
            <li>承辦商公司名稱</li>
            <li>性別</li>
          </ul>
        </li>
        <li>聯絡資料：
          <ul>
            <li>電郵地址</li>
            <li>電話號碼</li>
          </ul>
        </li>
        <li>核實資料：
          <ul>
            <li>核實您身份所需之資料（如適用）</li>
          </ul>
        </li>
      </ul>
      
      <div>
        您所提供的個人資料可能會用於以下目的：
      </div>
      
      <ul>
        <li>管理廠房承辦商、確保廠房安全與保安、執行出入權限管制，以及履行法定合規要求；</li>
        <li>出於承辦商管理、廠區出入及保安之目的核實您的身份；</li>
        <li>基於審計、保安、法律及法規遵從之目的保存記錄，以符合《個人資料（私隱）條例》（PD(P)O）項下的法律及法規義務。</li>
      </ul>
      
      <div>
        我們僅會出於上述目的處理您的個人資料；除法律規定外，未經您的同意，我們不會將其用於任何其他目的。
      </div>
      
      <div>
        若未能提供所需個人資料，可能會影響 SCCHK 管理承辦商行政、廠區出入、保安要求或合規義務之能力。然而，這並不會對 SCCHK 提供的任何其他現有產品或服務產生影響。
      </div>

      <div><b>2. 個人資料的披露</b></div>

      <div>
        在為實現本通知所述目的之必要情況下，SCCHK 可能會向其集團旗下公司、服務供應商、專業顧問、監管機構或政府當局披露個人資料。
      </div>
      
      <div>
        若個人資料轉移至香港境外，我們將依據適用規定落實適當的保障措施。
      </div>

      <div><b>3. 個人資料的保留</b></div>

      <div>
        我們只會在達致收集個人資料目的所需的期間內保留您的個人資料。個人資料可能因記錄保存、審計、法律及法規遵從之目的而被保留。當相關目的已完成且無需進一步保留時，我們將根據公司資料保留政策安全刪除或匿名化有關個人資料。
      </div>

      <div><b>4. 個人資料的保安措施</b></div>
      
      <div>
        SCCHK 將採取一切合理及切實可行的措施，以根據適用資料保障規定保護個人資料，並維持其安全性及準確性。為保護您的個人資料，SCCHK 已實施多項保安措施，包括但不限於：
      </div>

      <ul>
        <li>我們使用加密技術保障個人資料的安全，確保資料在傳輸及儲存過程中均受到保護，以防止未經授權的存取或攔截。</li>
        <li>我們實施嚴格的存取權限控制，確保僅限經授權人員存取個人資料，並嚴格遵循「有需要知情（Need-to-know）」原則授予權限。</li>
        <li>我們定期監控及審計系統，以便迅速發現並應對任何可疑活動或潛在的安全漏洞。</li>
      </ul>
      
      <div>
        SCCHK 採取合理的技術及組織措施，以防止個人資料遭受未經授權的存取、使用、披露、更改或遺失。
      </div>

      <div><b>5. 資料當事人權利</b></div>

      <div>
        根據香港適用法例，您有權：
      </div>
      
      <ul>
        <li>查閱我們所持有您的個人資料；</li>
        <li>更正我們所持有您的個人資料。</li>
      </ul>

      <div>
        如欲行使您在《個人資料（私隱）條例》下的權利，請按照第 8 節「聯絡我們」所載資料與我們聯絡。SCCHK 在處理要求前可採取合理步驟核實提出要求人士的身份。
      </div>

      <div><b>6. 公開披露</b></div>

      <div>
        除法律許可或規定外，SCCHK 不會披露個人資料。
      </div>

      <div><b>7. 私隱政策</b></div>
      
      <div>
        如欲進一步了解 SCCHK 的私隱政策，請瀏覽<a href="https://www.swirecocacola.com/en/Others/Privacy-Policies.html" target="_blank">以下網站</a>。
      </div>

      <div><b>8. 聯絡我們</b></div>
      
      <div>
        如您對 SCCHK 收集、處理或保留個人資料的方式有任何疑問，或希望行使您作為資料當事人的權利，請透過以下途徑與我們聯絡：
      </div>
      
      <ul>
        <li><b>個人資料私隱保障辦公室</b></li>
        <li><b>電郵：</b> dpo@hk.swirecocacola.com</li>
        <li><b>地址：</b> 香港新界沙田小瀝源源順圍 17-19 號 太古可口可樂香港 品質、安全與環境部（QSE Department）</li>
      </ul>
    `,
    localLanguageName: '繁體中文'
  },
  [BusinessRegion.Taiwan]: {
    title: '蒐集個人資料告知事項暨個人資料提供同意說明 / Personal Information Collection Statements',
    enContent: `
      <div>
        When you, or the organization, unit, or company you belong to, enter our company (Swire Coca-Cola Beverages Limited Taiwan Branch, Swire Foods Limited Taiwan Branch), and before you provide your personal data to us, we are required by the Personal Data Protection Act to inform you of the following:
      </div>

      <div><b>1. Personal Information Collecting Entities:</b></div>

      <div>
        Swire Coca-Cola Beverages LTD, Taiwan Branch and Swire Coca-Cola(S&D) Limited Taiwan Branch (hereinafter collectively referred to as “the Company”).
      </div>  

      <div><b>2. Purpose of Collection:</b></div>

      <div>
        The Company collects personal information of you, or of the representatives, authorized persons, contacts, business executors, and/or other designated personnel of the agencies, entities, units, or companies to which you belong, for specific purposes necessary for the Company’s operations. Such purposes include the following: personal insurance, procurement operations and supplier management, contractual or similar legal relationships, commercial and technical exchanges, education and training administration, facility access control and safety management, incident or accident investigation, information security management, credit investigation, credit management and guarantee establishment, system operations, accounting and financial management, statistical surveys and data analysis, insurance and tax-related requirements, the collection, processing, and use of personal data conducted by non-government agencies in accordance with statutory obligations, and other business purposes necessary for fulfilling objectives specified in the Company’s articles of incorporation or business scope.
      </div>

      <div><b>3. Categories of Personal Information Collected:</b></div>

      <div>
        To fulfill the specified purposes, the Company may collect the following personal information in accordance with operational requirements: name, National Identification Number, information for insurance purposes (including but not limited toaforementioned information ), mailing address, contact information (phone numbers, email addresses, etc.), professional licenses or certificates, and other information that may directly or indirectly identify you as an individual. For the purposes of emergency rescue and incident investigation, your date of birth, gender, blood type, medical or health records, and biometric information may be collected when necessary.
      </div>

      <div><b>4. Period, Location, Recipients, and Methods of Use of Personal Information:</b></div>

      <ol>
        <li>Retention Period: For as long as the purpose of collection exists and within the required retention period prescribed by law. Exceptions apply where retention is necessary for the performance of duties or business operations or where the data subject has provided written consent.</li>
        <li>Location: Regions where the Company conducts business operations and where its servers/cloud storage are located.</li>
        <li>Recipients: The Company, its affiliated companies, business partners, and entities to whom personal information must be provided in accordance with law.</li>
        <li>Methods: Personal information will be used reasonably within the scope of the specified purposes and for administrative assistance requested by public authorities. Should the collection, processing, or use of personal information exceed the purposes, the Company shall obtain your separate consent in advance. The Company may collect, process, and use your personal data through paper records, computer systems, electronic files, telephone, email, fax, mail, or other lawful and reasonable methods.</li>
      </ol>

      <div><b>5. Rights of the Data Subject:</b></div>

      <div>
        Unless subject to circumstances set forth in Article 10 of the Personal Data Protection Act, you may exercise the following rights in accordance with Article 3 of the Personal Data Protection Act with respect to your personal information held by the Company:
      </div>
      
      <ol>
        <li>Request to access or review your personal information.</li>
        <li>Request copies of your personal information.</li>
        <li>Request supplementation or correction of your personal information.</li>
        <li>Request cessation of the collection, processing, or use of your personal data.</li>
        <li>Request deletion of your personal data.</li>
      </ol>

      <div>
        If you wish to exercise any of the above rights, please submit a written request by mail to No. 46, Xingbang Road, Taoyuan District, Taoyuan City, or contact the Company by calling 0800-018-818.
      </div>

      <div><b>6. Provision of Personal Information:</b></div>

      <ol>
        <li>You may freely choose whether to provide your personal information. However, if you refuse to provide necessary information, the Company will be unable to offer relevant services or conduct related business operations.</li>
        <li>Please provide accurate, up-to-date, and complete personal information in accordance with the requirements of each service. Should there be any changes to your personal information, you must proactively request an update or correction.</li>
        <li>If you provide incorrect, outdated, incomplete, or misleading information that results in damage to your rights or interests, the Company shall not be liable for any related compensation.</li>
        <li>If the personal information you provide involves intentional impersonation of another person, violation of public morals, infringement upon the rights of others, or violation of laws or regulations, the Company reserves the right to refuse or terminate your use of the Company’s services, and you shall bear full legal responsibility.</li>
        <li>If you fail to provide accurate personal information, the Company will be unable to offer services related to the specified purpose.</li>
      </ol>

      <div>
        <b>7. </b>For the purpose of carrying out business operations related to specific purposes, you agree that the Company may delegate the collection, processing, or use of your personal information to third-party entities. The Company shall, however, duly perform its obligations of selection and supervision over such entrusted parties.
      </div>

      <div>
        <b>8. </b>I have thoroughly read and fully understand the above statement regarding the collection, processing, and use of my personal data. I confirm that the content of this statement complies with the requirements of the Personal Data Protection Act. Having been informed of the purposes of collection, the types of data, and the retention period, location, recipients, and methods, I hereby agree to provide my personal data in accordance with the terms and conditions stated herein.
      </div>
    `,
    localContent: `
      <div>
        當您本人或您所屬的機關、單位或公司進入本公司(英屬維京群島商太古可口可樂股份有限公司台灣分公司、英屬維京群島商太古食品股份有限公司台灣分公司)時，為踐行相關作業並遵守個人資料保護法規定，在您提供個人資料予本公司前，依法告知下列事項：
      </div>

      <div><b>一、 蒐集機關：</b></div>

      <div>
        英屬維京群島商太古可口可樂股份有限公司台灣分公司、英屬維京群島商太古食品股份有限公司台灣分公司，以下皆稱皆本公司。 
      </div>  

      <div><b>二、 蒐集目的：</b></div>

      <div>
        本公司基於人身保險、請採購作業與供應商管理、契約或類似契約或其他法律關係、商業與技術交流、教育與訓練行政、場所進出安全管理及事故調查、資通安全與管理、徵信、信用管理及擔保設定、系統營運、帳務管理、調查統計與研究分析、辦理保險及稅務需求、非公務機關依法定義務所進行個人資料之蒐集處理及利用，以及其他合於本公司章程或營業項目所定業務需要之特定目的，蒐集您或您所屬的機關、單位或公司之代表人、被授權人、聯絡人、執行業務人員及或其他指定人員之個人資料。
      </div>

      <div><b>三、蒐集個人資料之類別：</b></div>

      <div>
        為執行特定目的業務，本公司依各項作業需求蒐集您下列個人資料： 姓名、身份證統一編號、保險資料(包含但不限於前述)、通訊地址、連絡方式(電話號碼、電子郵件地址)、專業證照/執照及其他得以直接或間接識別您個人之資料，另為安全事故救護及調查目的，必要時會蒐集您的生日, 性別、血型、醫療/病歷紀錄及個人特徵。
      </div>

      <div><b>四、個人資料利用之期間、地區、對象及方式：</b></div>

      <ol>
        <li>期間：蒐集目的未消失前與法令規定之必要保存期間內，但因執行職務或業務所必須或經當事人書面同意者，不在此限。</li>
        <li>地區：本公司執行業務之地區以及伺服器/雲端主機所在地區。</li>
        <li>對象：以本公司、本公司之關係企業、與本公司業務往來之機關及其他依法須提供之對象為限。</li>
        <li>方式：本公司將於蒐集之特定目的及其他公務機關請求行政協助之目的範圍內，合理利用您的個人資料，倘有逾此目的外之蒐集、處理、利用行為，將另行取得您同意。本公司蒐集、處理及利用台端之個人資料以紙本、電腦系統、電子檔案、電話、電子郵件、傳真、郵寄或其他合法及合理方式使用。</li>
      </ol>

      <div><b>五、當事人權利行使：</b></div>

      <div>
        除有個資法第10條所規定之例外情形外，您可依個資法第3條規定，就本公司所保有您的個人資料行使以下權利：
      </div>
      
      <ol>
        <li>1.查詢或請求閱覽。</li>
        <li>2.請求製給複製本。</li>
        <li>3.請求補充或更正。</li>
        <li>4.請求停止蒐集、處理及利用。</li>
        <li>5.請求刪除。</li>
      </ol>

      <div>
        若您欲執行上述權利，請以書面申請寄送至桃園市桃園區興邦路46號，或撥打0800-018-818與本公司聯繫。
      </div>

      <div><b>六、個人資料之提供：</b></div>

      <ol>
        <li>您可自由選擇是否提供相關個人資料，惟若拒絕提供個人資料，本公司將無法提供相關服務或辦理相關業務。</li>
        <li>請依各項服務需求提供您本人正確、最新及完整的個人資料，若您的個人資料有任何異動，請主動向本公司申請更正。</li>
        <li>若您提供錯誤、過時、不完整或具誤導性的資料，而損及您的相關權益，本公司將不負相關賠償責任。</li>
        <li>若您所提供的個人資料有刻意冒用他人名義、違反善良風俗、侵害他人權利或涉有其他違反法令之虞，我們得拒絕或取消您使用我們的服務，並應由您自行承擔一切法律責任。</li>
        <li>若您未提供正確之個人資料，本公司將無法為您提供特定目的相關業務或服務。</li>
      </ol>

      <div>
        <b>七、</b>為執行特定目的相關業務，您同意本公司為得因系統或業務需要下，委託其他機關蒐集、處理、利用您所提供個人資料，但本公司將善盡選任與監督之責。
      </div>

      <div>
        <b>八、</b>本人已詳閱並充分理解上述個人資料蒐集、處理及利用之告知事項，確認本告知內容符合《個人資料保護法》之規定，並已知悉蒐集目的、資料類別、利用期間、地區、對象及方式等事項後，同意依其內容提供本人之個人資料。
      </div>
    `,
    localLanguageName: '繁體中文'
  },
  [BusinessRegion.Vietnam]: {
    title: 'Đồng ý thu thập và xử lý dữ liệu cá nhân / Personal Data Collection and Processing Consent',
    enContent: `
      <div>
        By putting tick to choose this box to confirm your agreement, you, suppliers’ companies and employees understand and fully agree that the Coca-Cola Beverages Viet Nam Company Limited (Coca-Cola Company) may collect and process certain of your personal data, suppliers’ companies and employees through websites, mobile applications (“Applications”), or by automated or manual means for the purpose of ensuring security and legitimate interests of the Coca-Cola Company. The personal data we collect may include, but is not limited to, your name, phone number, ID card number/citizen identification number, passport number, driver’s license number, vehicle registration number, personal tax identification number, social insurance number, health insurance card number, health status, and other information that you or your related parties may provide to us in connection with visits, performances, etc. of agreed services with the Coca-Cola Company. The Coca-Cola Company may share your personal data with relevant organizations or individuals, within or outside Vietnam, in accordance with the local law.
      </div>
      
      <div>
        Personal data will only be stored for the period necessary to achieve the purpose of processing or as required by applicable law.
      </div>
      
      <div>
        The Coca-Cola Company will apply appropriate personal data protection measures. In the event of a data breach, the Coca-Cola Company will comply with all reporting obligations and take remedial measures under applicable data protection laws.
      </div>
      
      <div>
        You have rights and obligations under applicable data protection laws. To exercise these rights or raise questions/complaints regarding the Company's processing of personal data, please contact us at EOSH Office in Plant. To learn more about our full privacy policy, please visit our Company website <a href="https://www.coca-cola.com/vn/vi/legal/privacy-policy" target="_blank">Privacy Policy | Coca-Cola</a>.
      </div>
    `,
    localContent: `
      <div>
        Bằng cách đánh dấu xác nhận chọn nội dung này, bạn, công ty của nhà cung cấp và nhân viên của nhà cung cấp đã hiểu rõ và đồng ý  rằng Công Ty TNHH Nước Giải Khát Coca-Cola Việt Nam (Công ty Coca-Cola) có thể thu thập và xử lý một số dữ liệu cá nhân của bạn, công ty của nhà cung cấp và nhân viên của nhà cung cấp trên các trang web, ứng dụng di động (Ứng dụng) hoặc các cách thức tự động hoặc thủ công nhằm mục đích đảm bảo an ninh và lợi ích chính đáng của Công Ty Coca-Cola. Dữ liệu cá nhân mà chúng tôi thu thập có thể bao gồm, nhưng không giới hạn như tên, số điện thoại, số chứng minh nhân dân/căn cước công dân, số hộ chiếu, số giấy phép lái xe, số biển số xe, số mã số thuế cá nhân, số bảo hiểm xã hội, số thẻ bảo hiểm y tế, tình trạng sức khỏe, các thông tin khác mà bạn, công ty của nhà cung cấp và nhân viên của nhà cung cấp hoặc các bên liên quan có thể cung cấp cho chúng tôi liên quan đến hoạt động, các dịp viếng thăm, … để thực hiện các dịch vụ đã thống nhất thỏa thuận với Công ty Coca-Cola. Công ty Coca-Cola có thể chia sẻ dữ liệu cá nhân của bạn tới các tổ chức hoặc cá nhân có liên quan, trong hoặc ngoài lãnh thổ Việt Nam, phù hợp với quy định của pháp luật.
      </div>
      
      <div>
        Dữ liệu cá nhân sẽ chỉ được lưu trữ trong thời hạn cần thiết để đạt được mục đích xử lý hoặc theo yêu cầu của pháp luật hiện hành.
      </div>
      
      <div>
        Công Ty Coca-Cola sẽ áp dụng các biện pháp bảo vệ dữ liệu cá nhân phù hợp. Trong trường hợp có vi phạm đối với dữ liệu, Công ty Coca-Cola sẽ tuân thủ tất cả các nghĩa vụ báo cáo và thực hiện các biện pháp khắc phục theo pháp luật bảo vệ dữ liệu hiện hành.
      </div>
      
      <div>
        Bạn, công ty của nhà cung cấp và nhân viên của nhà cung cấp có quyền và nghĩa vụ theo pháp luật bảo vệ dữ liệu hiện hành. Để có thể thực hiện các quyền này hoặc đưa ra các thắc mắc/khiếu nại liên quan đến hoạt động xử lý dữ liệu cá nhân của Công ty Coca-Cola, vui lòng liên hệ với Phòng Quản lý Môi trường An toàn Sức Khỏe của chúng tôi. Để tìm hiểu thêm về chính sách quyền riêng tư đầy đủ, vui lòng truy cập website của Công ty Coca-Cola chúng tôi <a href="https://www.coca-cola.com/vn/vi/legal/privacy-policy" target="_blank">Privacy Policy | Coca-Cola</a>.
      </div>
    `,
    localLanguageName: 'Tiếng Việt'
  },
  [BusinessRegion.Cambodia]: {
    title: 'សេចក្តីជូនដំណឹងអំពីការប្រមូលព័ត៌មានផ្ទាល់ខ្លួន / Personal Information Collection Statement',
    enContent: `
      <div>
        This Personal Information Collection Statement (the “Statement”) is made in accordance with the requirements under the Personal Data Protection Decree and the Privacy Policy of Swire Coca-Cola Cambodia (“SCCKH”, “we”, “us” and “our”). The most current version will be available on <a href="https://www.swirecocacola.com/en/Others/Privacy-Policies.html" target="_blank">our website</a>.
      </div>

      <div><b>1. Scope and Purpose of Collection of Personal Data</b></div>

      <div>
        When you visit our premises or before visiting our premises for performing contractor work, we may collect the following types of data:
      </div>
      
      <ol>
        <li>Identification Data
            <ol>
                <li>Name</li>
                <li>Phone number</li>
                <li>Company’s name</li>
            </ol>
        </li>
        <li>Visit Details
            <ol>
                <li>Safety-related qualifications or records</li>
                <li>Specific details about your date and time of entry, exit, and visiting purpose</li>
                <li>Name of the individual or department you intend to visit</li>
            </ol>
        </li>
        <li>CCTV Footage
            <ol>
                <li>Video recordings from security cameras for safety and security purposes</li>
            </ol>
        </li>
      </ol>
      
      <div><b>Purpose of Use:</b></div>
      
      <ol>
        <li>Ensuring the security and safety of our premises, employees, and visitors</li>
        <li>Managing visitor records and facilitating entry</li>
        <li>Other activities are related to the above processing purposes</li>
      </ol>
      
      <div>
        We will only process your personal data for the purposes described above and will not use it for other purposes without your consent, unless required by law.
      </div>

      <div><b>2. Retention of Personal Data</b></div>

      <div>
        Your Personal Data will be retained as needed for its intended purpose and securely deleted or anonymized per our retention policies, unless required by law.
      </div>

      <div><b>3. Security Measures of Personal Data</b></div>

      <div>
        SCCKH is committed to safeguarding your Personal Data by adhering to the following basic principles of Personal Data security:
      </div>
      
      <ol>
        <li>We collect and process only necessary Personal Data, avoiding excess or irrelevant information.</li>
        <li>We uphold confidentiality and integrity, protecting data from unauthorized access or alterations.</li>
        <li>We ensure transparency by informing individuals about data collection, processing, and sharing.</li>
      </ol>

      <div><b>4. Data Subject Rights</b></div>

      <div>
        Under the Personal Data Protection Act (PDPA), you have the legal right to request access to and/or rectification of your personal data. To submit such a request, whether personally or through an authorized representative. Please contact us as specified in Section 6: Contact Us.
      </div>

      <div><b>5. Public Disclosure</b></div>

      <div>
        We will not publicly disclose your Personal Data without your explicit consent, except as required by law or government regulations.
      </div>

      <div><b>6. Contact Us</b></div>
      
      <div>
        If you have any questions about how SCCKH collects, processes or retains the Personal Data collected, or if you wish to exercise your rights as a data subject, please contact us as specified below:
      </div>
      
      <div>
        <div><b>Data Protection Office</b></div>
        <div><b>Name: </b>Aun Serey</div>
        <div><b>Email: </b>aserey@coca-cola.com.kh</div>
        <div><b>Address: </b>No. 287, National Road No 5, Mittapheap Village, Russey Keo District, Phnom Penh 120703, Cambodia</div>
      </div>
    `,
    localContent: `
      <div>
        ការប្រមូលព័ត៌មានផ្ទាល់ខ្លួននេះ ធ្វើឡើងដោយអនុលោមតាមលក្ខខណ្ឌ ក្រោមក្រិត្យស្តីពីការការពារទិន្នន័យផ្ទាល់ខ្លួន និងគោលការណ៍ឯកជនភាពរបស់ក្រុមហ៊ុន Swire Coca-Cola Cambodia ។ កំណែបច្ចុប្បន្នបំផុតនឹងមាននៅលើ<a href="https://www.swirecocacola.com/en/Others/Privacy-Policies.html" target="_blank">គេហទំព័ររបស់យើង</a>។
      </div>

      <div><b>១. វិសាលភាព និងគោលបំណងនៃការប្រមូលទិន្នន័យ</b></div>

      <div>
        នៅពេលអ្នកចូលទៅកាន់បរិវេណក្រុមហ៊ុន ឬមុនពេលទៅទស្សនាបរិវេណរបស់យើងដើម្បីអនុវត្តការងារអ្នកម៉ៅការ យើងអាចប្រមូលទិន្នន័យប្រភេទ ដូចខាងក្រោម៖
      </div>
      
      <ol>
        <li>ទិន្នន័យអត្តសញ្ញាណ
            <ol>
                <li>o	ឈ្មោះ</li>
                <li>លេខទូរស័ព្ទ</li>
                <li>ឈ្មោះក្រុមហ៊ុន</li>
            </ol>
        </li>
        <li>ព័ត៌មានលម្អិតនៃការចូល
            <ol>
                <li>វិញ្ញាបនបត្របញ្ជាក់សមត្ថភាព ឬកំណត់ត្រាទាក់ទងនឹងសុវត្ថិភាព</li>
                <li>កាលបរិច្ឆេទ និងពេលវេលាជាក់លាក់នៃការចូល ចេញ និងគោលបំណងនៃការចូល</li>
                <li>ឈ្មោះបុគ្គល ឬនាយកដ្ឋានដែលអ្នកមានបំណងទៅជួប</li>
            </ol>
        </li>
        <li>វីដេអូ CCTV
            <ol>
                <li>ការថតវីដេអូពីកាមេរ៉ាសុវត្ថិភាពក្នុងគោលបំណង សន្តិសុខ និងសុវត្ថិភាព</li>
            </ol>
        </li>
      </ol>
      
      <div><b>ទិន្នន័យផ្ទាល់ខ្លួនដែលអ្នកផ្តល់ឲ្យនេះ និងអាចត្រូវបានប្រើប្រាស់សម្រាប់គោលបំណងដូចខាងក្រោម៖</b></div>
      
      <ol>
        <li>ធានាបាននូវ សន្តិសុខ និង សុវត្ថិភាព ក្នងបរិវេណក្រុមហ៊ុន បុគ្គលិក និង អ្នកទស្សនកិច្ច</li>
        <li>គ្រប់គ្រងកំណត់ត្រា និងសម្របសម្រួលការចេញ/ចូល របស់អ្នកទស្សកិច្ច </li>
        <li>សកម្មភាពផ្សេងៗទៀត</li>
      </ol>
      
      <div>
        យើងនឹងដំណើរការតែទិន្នន័យផ្ទាល់ខ្លួនរបស់អ្នក សម្រាប់តែគោលបំណងដែលបានរៀបរាប់ខាងលើប៉ុណ្ណោះ ហើយនឹងមិនប្រើវាសម្រាប់គោលបំណងផ្សេងទៀត ដោយគ្មានការយល់ព្រមពីអ្នកទេ លុះត្រាតែមានតម្រូវការដោយច្បាប់។
      </div>

      <div><b>២. ការរក្សាទុកទិន្នន័យ</b></div>

      <div>
        ទិន្នន័យផ្ទាល់ខ្លួនរបស់អ្នកនឹងត្រូវ បានរក្សាទុក ហើយនិងត្រូវបានលុបដោយសុវត្ថិភាព ស្របតាមគោលការណ៍នៃការរក្សាទុករបស់យើង លុះត្រាតែតម្រូវដោយច្បាប់។
      </div>

      <div><b>៣. វិធានការសុវត្ថិភាពនៃទិន្នន័យ</b></div>

      <div>
        យើងប្តេជ្ញាការពារទិន្នន័យផ្ទាល់ខ្លួនរបស់អ្នកដោយប្រកាន់ខ្ជាប់នូវគោលការណ៍ជាមូលដ្ឋានខាងក្រោមនៃសុវត្ថិភាពទិន្នន័យផ្ទាល់ខ្លួន៖
      </div>
      
      <ol>
        <li>យើងប្រមូល និងដំណើរការតែទិន្នន័យផ្ទាល់ខ្លួនចាំបាច់ ជៀសវាងការប្រមូលព័ត៌មានលើស ឬមិនពាក់ព័ន្ធ។</li>
        <li>យើងរក្សាការសម្ងាត់ និងសុចរិតភាព ការពារទិន្នន័យពីការចូលប្រើ ឬការផ្លាស់ប្តូរដោយគ្មានការអនុញ្ញាត។</li>
        <li>	យើងធានានូវ តម្លាភាពដោយការជូនដំណឹងបុគ្គល អំពីការប្រមូលទិន្នន័យ ដំណើរការ និងការចែករំលែកភាគីដទៃ។</li>
      </ol>

      <div><b>៤. សិទ្ធិម្ចាស់ទិន្នន័យ</b></div>

      <div>
        នៅក្រោមច្បាប់ការពារទិន្នន័យផ្ទាល់ខ្លួន (PDPA) អ្នកមានសិទ្ធិស្របច្បាប់ក្នុងការស្នើសុំការចូលប្រើ និង/ឬកែតម្រូវទិន្នន័យផ្ទាល់ខ្លួនរបស់អ្នក។ ដើម្បីដាក់សំណើបែបនេះ មិនថា ដោយផ្ទាល់ ឬតាមរយៈអ្នកតំណាងដែលមានការអនុញ្ញាត។ សូមទាក់ទងមកយើងខ្ញុំដូចដែលបានបញ្ជាក់ក្នុងផ្នែកទី 6៖ ទំនាក់ទំនងយើងខ្ញុំ។
      </div>

      <div><b>៥. ការបង្ហាញជាសាធារណៈ</b></div>

      <div>
        យើងនឹងមិនបង្ហាញជាសាធារណៈនូវទិន្នន័យផ្ទាល់ខ្លួនរបស់អ្នកដោយគ្មានការយល់ព្រមច្បាស់លាស់របស់អ្នកទេ លើកលែងតែតម្រូវដោយច្បាប់ ឬបទប្បញ្ញត្តិរបស់រដ្ឋាភិបាល។
      </div>

      <div><b>៦. ទំនាក់ទំនង</b></div>
      
      <div>
        ប្រសិនបើយើងមានសំណួរណាមួយអំពីរបៀបដែលក្រុមហ៊ុន SCCKH ប្រមូល ដំណើរការ ឬរក្សាទុកទិន្នន័យផ្ទាល់ខ្លួនដែលបានប្រមូល ឬប្រសិនបើអ្នកចង់អនុវត្តសិទ្ធិរបស់អ្នកក្នុងនាមជាម្ចាស់ទិន្នន័យ សូមទាក់ទងមកយើងខ្ញុំដូចដែលបានបញ្ជាក់ជូនខាងក្រោម៖
      </div>
      
      <div>
        <div><b>ការិយាល័យការពារទិន្នន័យ</b></div>
        <div><b>ឈ្មោះ៖</b>លោក អូន សេរី</div>
        <div><b>អ៊ីមែល៖</b>aserey@coca-cola.com.kh</div>
        <div><b>អាសយដ្ឋាន៖</b>អាគារ ២៨៧ ផ្លូវជាតិលេខ ៥ ភូមិមិត្តភាព ខណ្ឌឫស្សីកែវ រាជធានីភ្នំពេញ, ១២០៧០៣</div>
      </div>
    `,
    localLanguageName: 'ភាសាខ្មែរ'
  },
  [BusinessRegion.UnitedStates]: {
    title: '',
    enContent: ''
  },
  [BusinessRegion.Thailand]: {
    title: '',
    enContent: '',
    localContent: '',
    localLanguageName: 'ภาษาไทย'
  },
  [BusinessRegion.Laos]: {
    title: '',
    enContent: '',
    localContent: '',
    localLanguageName: 'ພາສາລາວ'
  }
};